import { render, staticRenderFns } from "./DetailAide.vue?vue&type=template&id=095b4c7a&"
import script from "./DetailAide.vue?vue&type=script&lang=js&"
export * from "./DetailAide.vue?vue&type=script&lang=js&"
import style0 from "./DetailAide.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports